import { ThemeFunction } from '../../utils';

export const APPRECIATION_COLOR: ThemeFunction<string> = ({ palette }) => palette.secondary.main;

export const RENTAL_INCOME_COLOR: ThemeFunction<string> = ({ palette }) => palette.primary.main;
